import axios from 'axios';

const defaultState = {
  journal: null,
  loadedPages: []
};

export default {

  namespaced: true,

  state: {
    journal: null,
    loadedPages: [],
    loading: false
  },

  mutations: {
    setJournal(state, data) {
      state.journal = data;
    },
    
    setLoadedPages(state, pages) {
      state.loadedPages = [...pages];
    },

    setLoading(state, isloading) {
      state.loading = isloading;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchJournal({ commit }, { id, filter }) {
      return axios.post(process.env.VUE_APP_API_URL + `search/${id}`, filter)
      .then(({ data }) => commit('setJournal', data));
    },

    fetchMatchedWords({ state, commit }, { page, keywords }) {
      const { pageId } = page;

      return axios.post(process.env.VUE_APP_API_URL + 'pages/words', { 
        pageId,
        keywords
      })
      .then(({ data }) => {
        const _page = Object.assign({}, page, { vectors: data });
        const _loadedPages = [...state.loadedPages, _page];

        commit('setLoadedPages', _loadedPages);
      });
    },

    getPageContent(_, page_id) {
      return axios.post(`${process.env.VUE_APP_API_URL}pages/download/${page_id}`)
    },
  }

};